/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Math.Easing.Linear

module.exports = require('./Linear');



//////////////////
// WEBPACK FOOTER
// ./math/easing/linear/index.js
// module id = 294
// module chunks = 0